<template>
	<!-- <f7-page class=""> -->
  <div class="page">
    <bottom-toolbar></bottom-toolbar>
    <div class="page-content">

      <!--<page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Contact Group Detail" :menuAccess="true" :returnPreviousPage="true"></page-nav-bar>-->

      <div class="layoutTop"/>

      <b-container fluid>
        <b-row>
          <b-col md="10" offset-md="1">
            <back-button></back-button>
            <div class="panel21 panel-default">

              <div class="panel-heading">
                <h4 class="content-block labelAccordionForm">
                  <f7-icon fa="address-book" class="formIcon"></f7-icon>
                  {{ $t('contacts.cntct_grp_dtls') }}
                </h4>
              </div>

              <b-row>
                <b-col sm="6" class="form-group">
                  <form-read-group-label-input :inputLabel="$t('common.nme')"
                    :inputValue="contactGroupLabel">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="form-group">
                  {{ $t('contacts.cntcts_in_ths_grp') }}
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <ul class="list-group" v-if="1" disabled>
                    <li class="list-group-item" v-for="value in this.contactsArray" v-bind:key="value.id">{{ value.label }}</li>
                  </ul>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row class="justify-content-start">
          <b-col md="3" offset-md="5" class="height-button">
            <f7-button
              class="button-action milkyBlockBlack"
              href="/account/editContactGroup/">
              <f7-icon icon="icon-edit" class="icon-float-sub-button"></f7-icon>
              <span>{{ $t('common.edit_label') }}</span>
            </f7-button>
          </b-col>
          <b-col md="3" class="height-button">
            <f7-button
              class="button-action milkyBlockBlack"
              @click="removeContactGroup">
              <!-- <i class="icon fa fa-times-circle" style="font-size: large;"></i> -->
              <f7-icon f7="close_round" class="button-delete"></f7-icon>
              <span>{{ $t('common.rm_label') }}</span>
            </f7-button>
          </b-col>
        </b-row>
      </b-container>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
	<!-- </f7-page> -->
</template>

<script>
import backButton from '@/components/common/backButton.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'back-button': backButton,
    'bottom-toolbar': bottomToolbar,
    'form-read-group-label-input': formReadGroupLabelInput,
    'page-nav-bar': pageNavBar
  },
  data () {
    return {
      contactGroupId: '',
      contactGroupLabel: '',
      contactIdArray: [],
      contactsArray: []
    }
  },
  created () {
    this.contactGroupId = this.$settings.currentContactGroup.id
    this.contactGroupLabel = this.$settings.currentContactGroup.label
    this.contactIdArray = this.$settings.currentContactGroup.contacts
    for (let i = 0; i < this.$engine.contacts.get().length; i++) {
      if (this.contactIdArray.includes(this.$engine.contacts.get()[i].id)) {
        this.contactsArray.push(this.$engine.contacts.get()[i])
      }
    }
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  methods: {
    removeContactGroup () {
      let that = this
      that.$f7.confirm('Are you sure to delete this contact group?', 'Operation confirmation', function () {
        that.$engine.contacts
        .deleteContactGroup(that.contactGroupId)
        .then(resp => {
          that.$f7.modal({
            title: 'Contact group deleted',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.contactGroupId = ''
            that.contactGroupLabel = ''
            that.contactIdArray = []
            that.contactsArray = []
            that.$f7.closeModal()
            that.$bus.$emit('refresh-cache-contacts')
            loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// CMContactGroupDetail.vue?e310fcb8